module.exports = __webpack_public_path__ + "img/lock-circle-black.c8cbdf13.svg";